import React from 'react'
import { Switch, Default } from 'react-if'

import {
  Tab
} from 'components'
import { useTabs } from 'hooks'
import { TabsProvider } from 'hooks/useTabs/provider'

import LogList from './components/LogList'

const LogComponent: React.FC = () => {
  const {
    controlTabs,
  } = useTabs(['Pesquisar'])

  return (
    <>
      <Tab {...controlTabs} />
      <Switch>
        <Default>
          <LogList />
        </Default>
      </Switch>
    </>
  )
}

const Log = () => {
  return (
    <TabsProvider>
      <LogComponent />
    </TabsProvider>
  )
}

export default Log
